import React from 'react';

const AppTitle = ({ as: Tag = 'h1', className = '', field = 'title' }) => {
    const config = window.APP_CONFIG;
    if (!config) return null;

    let title = '';
    if (field === 'title') {
        title = config.title
    }
    else if (field === 'slogan') {
        title = config.slogan
    }

    return <Tag className={className}>{title}</Tag>;
};

export default AppTitle;

/*
import AppTitle from './Components/Shared/AppTitle';

<AppTitle as="h2" className="text-primary-color fw-bold" />
*/
